import * as React from 'react';

import * as ManifestUI from '@project44/manifest-ds';

import { TFunctionComponent } from '../../../../shared/core/infrastructrue/types';
import {
  ICheckbox,
  IFormControl,
  ISelect,
  ITextField,
} from '../../domain/interfaces';

export class HTMLFormElementsFactory {
  public static readonly composeFormControl: TFunctionComponent<IFormControl> =
    (props) => {
      return <ManifestUI.FormControl {...props} />;
    };

  public static readonly composeTextInputField: TFunctionComponent<ITextField> =
    (props) => {
      return <ManifestUI.TextField {...props} />;
    };

  public static composeCheckbox: TFunctionComponent<ICheckbox> = (
    props: ICheckbox,
  ) => {
    return <ManifestUI.Checkbox {...props} />;
  };

  public static readonly composeSelect: TFunctionComponent<ISelect> = ({
    dropdownOptions,
    ...restOfProps
  }) => {
    return (
      <ManifestUI.Select {...restOfProps}>
        {dropdownOptions.map(({ displayValue, value }) => {
          return (
            <ManifestUI.SelectItem key={value} aria-label={value}>
              {displayValue}
            </ManifestUI.SelectItem>
          );
        })}
      </ManifestUI.Select>
    );
  };
}
